import { useMutation, useQuery } from "@tanstack/react-query";

import { Button, Checkbox, Col, DatePicker, Descriptions, Divider, Drawer, Form, message, Radio, Row, Select } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import { forwardRef, useImperativeHandle, useState } from "react";
import { hostname } from "../hooks/useEndeavour";

const UserBindingNotificationsDrawer = forwardRef((props, ref) => {
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [forceUpdate, setForceUpdate] = useState(0);
  const query = useQuery({
    queryKey: ["tag-list"],
    queryFn: () => {
      return axios
        .get(`${hostname}/pa-alliance/notification/tag`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        })
        .then((res) => {
          if (res.status !== 200) {
            message.error("Failed to fetch tag list");
            return [];
          }

          let options = res.data.payload.map((item) => ({
            label: item,
            value: item,
          }));

          return options;
        });
    },
  });

  const binding_user = useMutation({
    mutationFn: (value) => {
      return axios
        .post(`${hostname}/pa-alliance/notification/template/${data.id}/user`, value, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        })
        .then((res) => {
          if (res.status != 200) {
            message.error("Add Fail");
          }
          message.success("Add User Success");
          setLoading(false);
          setForceUpdate(forceUpdate + 1);
          props.onChange();
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });

  const onFinish = (value) => {
    setLoading(true);
    value.scheduled_at = value.scheduled_at.unix();
    binding_user.mutate(value);
  };

  const openDrawer = (data) => {
    setData(data);
    setOpen(true);
  };

  const closeDrawer = () => {
    setOpen(false);
    setLoading(false);
    form.resetFields();
  };

  useImperativeHandle(ref, () => ({
    openDrawer,
  }));

  return (
    <Drawer title="Notifications Information" open={open} onClose={closeDrawer} width={"800px"}>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Descriptions column={2} layout="vertical">
            <Descriptions.Item label="Title">{data?.title}</Descriptions.Item>
            <Descriptions.Item label="Type">{data?.type}</Descriptions.Item>

            <Descriptions.Item label="Channel">{data?.channel}</Descriptions.Item>
            <Descriptions.Item label="Prompt">
              <pre style={{ margin: 0, whiteSpace: "pre-wrap" }}>{JSON.stringify(data?.prompt, null, 2)}</pre>
            </Descriptions.Item>
            <Descriptions.Item label="Body">{data?.body}</Descriptions.Item>
          </Descriptions>

          <Divider orientation="left">Create Notification Task</Divider>
          <Form form={form} layout="vertical" onFinish={onFinish} title="Binding Notification">
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <Form.Item label="Send All" name="send_all">
                  <Radio.Group
                    defaultValue={false}
                    options={[
                      { label: "No", value: false },
                      { label: "Yes", value: true },
                    ]}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label="Tag" name="tag">
                  <Select mode="tags" options={query.data} />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label="User Email" name="users">
                  <Select mode="tags" placeholder="Enter user email" />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label="Scheduled At" name="scheduled_at" rules={[{ required: true }]}>
                  <DatePicker showTime minDate={dayjs()} style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Button type="primary" htmlType="submit" loading={loading}>
                  Submit
                </Button>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </Drawer>
  );
});

export default UserBindingNotificationsDrawer;
